// Helper function to format the date as month names
export const formatMonth = (dateString) => {
	const date = new Date(dateString);
	const options = { month: 'short', year: 'numeric' };
	return date.toLocaleDateString('en-US', options);
};

export const formatMonthDayYear = (inputDate) => {
	// Create a new Date object using the input date string
	const date = new Date(inputDate);

	const day = (date.getDate()).toString().padStart(2, '0');
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const year = date.getFullYear();


	const formattedDate = `${month}-${day}-${year}`;

	return formattedDate;
};
